module.exports = __webpack_public_path__ + "img/step-5.22645db6.png";